import React, { useEffect } from "react";
import {  useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import FormContainer from "../components/FormContainer";
import CheckoutSteps from "../components/CheckoutSteps";
import { savePaymentMethod } from "../actions/cartActions";
import { BOOK_PRODUCT_ID, PRINT_PRODUCT_ID } from '../constants/productConfig';


function PaymentScreen() {

    const { t } = useTranslation();
    const cart = useSelector(state => state.cart);
    const { shippingAddress, cartItems } = cart;

    const userLogin = useSelector(state => state.userLogin);
    const { userInfo } = userLogin;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isPhysicalCartItem = (item) => (
      Number(item.product) === BOOK_PRODUCT_ID ||
      Number(item.product) === PRINT_PRODUCT_ID ||
      !item.is_digital
    );


    useEffect(() => {
        if (!userInfo) {
            navigate('/login?redirect=payment');
        } else {
            const allDigital = cartItems && cartItems.length > 0 && 
                     cartItems.every(item => !isPhysicalCartItem(item));
            
            if (!allDigital && !shippingAddress.address) {
                navigate('/shipping');
            } else {
                dispatch(savePaymentMethod('PayPal'));
                navigate('/placeorder');
            }
        }
    }, [navigate, userInfo, shippingAddress, cartItems, dispatch]);

    
  return (
    <FormContainer>
      <CheckoutSteps step1 step2 step3 />
      <h1>{t('payment.redirecting')}</h1>

    </FormContainer>
  );
}





export default PaymentScreen;